import { FormHelperText, InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import Config from '../../config';
import { ArrowBackIcon, DissatisfiedIcon, FalconLogo, HidePassword, ShowPassword, SuccessIcon } from '../../icon';
import { AuthService } from '../../services/AuthService';
import { UserService } from '../../services/UserService';
import { AppRoutes } from '../routes/route.path';
import ButtonComponent from '../shared/button/button.component';
import { TextFieldLabels, appNote, buttonLabels, pageTitles } from '../shared/constants';
import DisplayContent from '../shared/display-content.component';
import FallbackUIComponent from '../shared/fallback-ui/fallback-page.component';
import { validateForm } from '../shared/form-validation';
import PasswordRequirements from './password-requriements.component';
import * as selector from "../../selectors/selectors";
import UnAuthComponent from '../layout/unauth.component';

interface Props {
}

const ResetPassword = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const location = useLocation();
    const navigate = useNavigate();
    const [userinput, setUserinput] = useState<{
        resetnewpassword: string;
        confirmPassword: string;
        showPassword: boolean;
        showSuccess: boolean;
        hasError: boolean;
        IsLoading: boolean;
        ValidatingToken: boolean;
    }>({
        resetnewpassword: "",
        confirmPassword: "",
        showPassword: false,
        showSuccess: false,
        hasError: false,
        IsLoading: false,
        ValidatingToken: true,
    })
    const [errors, setErrors] = useState<{
        resetnewpassword: string;
        confirmPassword: string;
    }>({
        resetnewpassword: "",
        confirmPassword: "",
    });
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    useEffect(() => {
        if (Config.API_URL) {
            validateToken();
        }
    }, [])

    const validateToken = () => {
        var urlParams = new URLSearchParams(location?.search);
        var token = urlParams.get("token") || null;

        if (!!token) {
            UserService.validateResetpassword(token)
                .then((res) => {
                    if (res.status === 200) setUserinput({ ...userinput, hasError: false, ValidatingToken: false })
                })
                .catch((error) => {
                    setUserinput({ ...userinput, hasError: true, ValidatingToken: false })
                });
        }
        else {
            setUserinput({ ...userinput, ValidatingToken: false })
        }
    }

    const resetPassword = (event: any) => {
        event.preventDefault();
        var urlParams = new URLSearchParams(window.location.search);
        var token = urlParams.get("token") || null;
        var password = userinput.resetnewpassword;
        setUserinput({ ...userinput, IsLoading: true })
        UserService.resetPassword(token, password).then((res) => {
            setUserinput({ ...userinput, showSuccess: true, IsLoading: false });
            localStorage.clear();
        })
            .catch((error) => {
                setUserinput({ ...userinput, hasError: true, IsLoading: false, showSuccess: false })
            });
    };
    const handleChange = (name: any, value: any) => {
        setUserinput((prevState) => ({ ...prevState, [name]: value }));
        if (name === "resetnewpassword") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                resetnewpassword: value.trim() === "" ? "Password cannot be blank" : "",
            }));
        }
    };

    useEffect(() => {
        if (userinput.resetnewpassword.trim() !== '') {
            validateForm({
                resetnewpassword: userinput.resetnewpassword,
                confirmPassword: {
                    newPassword: userinput.resetnewpassword,
                    confirmPassword: userinput.confirmPassword
                }
            },
                (Errors) => {
                    setErrors({ ...errors, ...Errors })
                })
        }
    }, [userinput.resetnewpassword, userinput.confirmPassword])

    const isFormValid = () => {
        if ((!errors.confirmPassword && !errors.resetnewpassword)
            && (!!userinput.resetnewpassword && !!userinput.confirmPassword)) {
            return false;
        }
        else return true;
    }
    const backtoLogin = () => {
        AuthService.clearSession();
    }
    const onClickShowPassword = () => {
        setUserinput({ ...userinput, showPassword: !userinput.showPassword })
    }

    const onClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword)
    }

    useEffect(() => {
        if (!!AuthService.loggedIn() && !!AuthService.is2FACompleted() && !!AuthService.isNewUser()) {
            navigate(AppRoutes.RESET_PASSWORD_NEW);
        }
        else if (!!AuthService.loggedIn() && !AuthService.is2FACompleted()) {
            navigate(AppRoutes.TWO_FACTOR_AUTHENTICATION)
        }
        else if (!!AuthService.isUserLoggedIn()) {
            navigate(UserService.hasSysAdminRole() ? AppRoutes.PHONE_NUMBERS : IsMobileDevice ? AppRoutes.CONVERSATIONS : AppRoutes.DASHBOARD)
        }
        else {
            const token = new URLSearchParams(window.location.search).get("token");
            navigate(`${AppRoutes.RESET_PASSWORD_NEW}?${!!token ? `token=${token}` : ""}`);
        }
    }, []);

    // useEffect(() => {
    //     if (!JSON.parse(localStorage.getItem("current-user"))) {
    //         navigate(AppRoutes.SIGN_IN);
    //         localStorage.clear();
    //     }

    //     if(AuthService.isUserLoggedIn()){
    //         navigate(UserService.hasSysAdminRole() ? AppRoutes.PHONE_NUMBERS : AppRoutes.DASHBOARD)
    //     }
    // }, [])

    const handleLogout = () => {
        AuthService.clearSession();
    }


    return (
        userinput.ValidatingToken ?
            <FallbackUIComponent className='w-p-100' />
            :
            <div className={`mx-auto d-flex flex-direction w-p-100  align-center ${IsMobileDevice ? 'py-6' : (!userinput.hasError && !userinput.showSuccess) ? '' : ''}  tooltip-z-index`} >
                {!userinput.hasError ? (
                    <>
                        {!userinput.showSuccess ? (
                            <div className={`w-p-100 h-p-100`}>
                                {
                                    !IsMobileDevice &&
                                    <div className={"d-flex h-p-20 w-p-100 align-center pl-15"}>
                                        <FalconLogo className="" />
                                    </div>
                                }
                                <div className={`d-flex mx-auto  w-p-80 h-p-60 align-center ${IsMobileDevice ? "flex-direction" : "justify-center"}`}>
                                    <div className={`${IsMobileDevice ? "w-p-100" : "w-p-50"} d-flex flex-direction justify-center align-center `}>
                                        <div>
                                            <p className={`${IsMobileDevice ? 'h2-medium t-align-center' : 'h1-medium'} color-login-headers `}>{pageTitles.UPDATE_PASSWORD}</p>
                                        </div>
                                        <PasswordRequirements passwordCheck={userinput.resetnewpassword} IsMobileDevice={IsMobileDevice} />
                                    </div>
                                    <div className={`${IsMobileDevice ? "w-p-100" : "w-p-50"} d-flex flex-direction justify-center align-center`}>
                                        <form
                                            noValidate
                                            autoComplete="no"
                                            onSubmit={resetPassword} className={"w-p-80"}
                                        >
                                            <TextField autoFocus
                                                error={!!errors.resetnewpassword}
                                                label={TextFieldLabels.NEW_PASSWORD}
                                                className='unauth-border disableEdgeIcon'
                                                type={userinput.showPassword ? "text" : "password"}
                                                placeholder="New password *"
                                                fullWidth
                                                name="resetnewpassword"
                                                value={userinput.resetnewpassword}
                                                onChange={(e) =>
                                                    handleChange(e.target.name, e.target.value)}
                                                variant="standard"
                                                inputProps={{ maxLength: 20 }}
                                                InputLabelProps={{
                                                    className: "w-space h4-regular",
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position='end' className="c-pointer" onClick={onClickShowPassword}>
                                                            {userinput.showPassword ? <HidePassword /> : <ShowPassword />}
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                            <FormHelperText className={`h5-regular color-primary-danger t-align-right ${errors.resetnewpassword ? "mb-1" : "mb-4"}`}>
                                                {errors.resetnewpassword}
                                            </FormHelperText>
                                            <TextField
                                                label={TextFieldLabels.CONFIRM_PASSWORD}
                                                error={!!errors.confirmPassword}
                                                type={showConfirmPassword ? "text" : "password"}
                                                fullWidth
                                                name="confirmPassword"
                                                placeholder="Confirm password"
                                                className='unauth-border disableEdgeIcon'
                                                value={userinput.confirmPassword}
                                                onChange={(e) =>
                                                    handleChange(e.target.name, e.target.value)
                                                }
                                                variant="standard"
                                                inputProps={{ maxLength: 20 }}
                                                InputLabelProps={{
                                                    className: "w-space h4-regular",
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position='end' className="c-pointer" onClick={onClickShowConfirmPassword}>
                                                            {showConfirmPassword ? <HidePassword /> : <ShowPassword />}
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                            <FormHelperText className={`h5-regular color-primary-danger t-align-right ${errors.confirmPassword ? "mb-1" : "mb-4"}`}>
                                                {errors.confirmPassword}
                                            </FormHelperText>
                                            <ButtonComponent ButtonLabel={"Update Password"} Variant={isFormValid() ? 'disabled-btn' : 'primary-btn'} Type={"submit"}
                                                OnClick={resetPassword}
                                                ClassName={`${isFormValid()
                                                    ? ""
                                                    : "c-pointer"} d-flex justify-center h4-regular ${IsMobileDevice && "h5-regular"} w-p-100 `} Loading={userinput.IsLoading} />

                                            <span className={`d-flex justify-center align-center c-pointer`} onClick={handleLogout}>
                                                <span className="d-flex align-center">
                                                    <ArrowBackIcon className={"c-pointer float-left w-2"}
                                                    />
                                                    <span className="h4-regular ml-1 color-back-to-login d-flex">{buttonLabels.BACK_TO_LOGIN}</span>
                                                </span>
                                            </span>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        )
                            :
                            <>
                                <div className={`d-flex h-p-20  align-center w-p-100  ${IsMobileDevice ? "mx-auto" : "pl-15 w-p-100"}`}>
                                    <FalconLogo className="" />
                                </div>
                                <div className="w-p-100 h-p-60 d-flex flex-direction justify-center align-center ">
                                    <DisplayContent
                                        cardTitleClass={"h1-medium color-login-headers"}
                                        cardTitle={appNote.PASSWORD_RESET_SUCCESSFUL}
                                        displayMsgClass={`h5-regular color-display-content`}
                                        btnClass={`c-pointer d-flex justify-center primary-btn ${IsMobileDevice ? "h2 mb-2" : "h4-regular"}`}
                                        btnLabel={buttonLabels.CONTINUE_TO_LOGIN}
                                        btnPath={AppRoutes.SIGN_IN}
                                        displayMsg={appNote.PASSWORD_UPDATE_SUCESS}
                                        displayIcon={SuccessIcon}
                                        IsMobileDevice={IsMobileDevice}
                                        IsReset={true} OnClick={backtoLogin}
                                    />
                                </div>
                            </>
                        }
                    </>
                ) : (
                    <>
                        <div className={`d-flex h-p-20  align-center ${IsMobileDevice ? "mx-auto" : "pl-15 w-p-100"}`}>
                            <FalconLogo className="" />
                        </div>
                        <div className="w-p-100 h-p-60 d-flex flex-direction justify-center align-center">
                            <DisplayContent
                                cardTitleClass={"h1-medium color-login-headers"}
                                btnClass={` c-pointer d-block t-align-center primary-btn  ${IsMobileDevice ? "h2" : "h4-regular mx-10"}`}
                                displayMsgClass={`h5-regular mx-4 color-login-subtitle t-align-center ${IsMobileDevice ? "h4" : "h5-regular"}`}
                                btnLabel={buttonLabels.FORGOT_PASSWORD} btnPath={AppRoutes.FORGOT_PASSWORD}
                                displayMsg={appNote.PASSWORD_LINK_EXPIRED}
                                displayIcon={DissatisfiedIcon}
                                IsMobileDevice={IsMobileDevice}
                            />
                        </div>
                    </>
                )
                }
            </div >
    )
}

export default (UnAuthComponent((ResetPassword)));
